module.exports = __webpack_public_path__ + "img/Eshwari_Kovoor.da43c9d6.png";